// COMPONENTS
import * as ComponentLibrary from "@picnicmedia/masanatemples123";
import { validateAdformReportingModal } from "../functions/validateAdformReportingModal";
import { logger } from "../../../../libs/logger";
import { AdformReportDownloadButtonProps } from "../types";
import { Google_Analytics_Event } from "../../../../libs/google-analytics";

/**
 * Component for download report button inside modal
 **/
export function AdformReportDownloadButton({ adformReportingModalInputs, scope, dateRangeRestriction, handleRequestAdformReport, name, id, user, notificationDispatch }: AdformReportDownloadButtonProps) {
  return (
    <ComponentLibrary.PCActionButton
      text="Download Report"
      textColor={"background-color-primary-3"}
      color={"color-neutral-1"}
      clickHandler={async () => {
        try {
          Google_Analytics_Event({ name: "adform_report_start", category: "reporting", action: "download", label: name });
          const validatedReportingModal = validateAdformReportingModal(adformReportingModalInputs.selectedMetrics, adformReportingModalInputs.selectedDates.start, adformReportingModalInputs.selectedDates.end, scope, dateRangeRestriction.start, dateRangeRestriction.end);
          if (validatedReportingModal) await handleRequestAdformReport(scope, name, id, adformReportingModalInputs.selectedDates, adformReportingModalInputs.selectedMetrics);
          Google_Analytics_Event({ name: "adform_report_success", category: "reporting", action: "download", label: name });
        } catch (error) {
          Google_Analytics_Event({ name: "adform_report_failure", category: "reporting", action: "download", label: name });
          logger({ error, user, context: { origin: "AdformReportDownloadButton_AdformReportDownloadButton" } });
          notificationDispatch({
            type: "ADD",
            payload: {
              header: "Error",
              message: error.message,
              type: "error",
              autoDismiss: false,
            },
          });
        }
      }}
    />
  );
}
